module.exports = __webpack_public_path__ + "img/img8.27c23617.png";